import { Typography, makeStyles } from '@material-ui/core';
import { useSelector } from 'store/redux/selector';

const useStyles = makeStyles({
  container: {
    marginTop: 10,
    marginBottom: 15,
    display: 'grid',
    gridTemplateColumns: '1.3fr 0.7fr',
    gridGap: 6,
    '& div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'flex-end',
    },
    '& p': {
      lineHeight: '15px',
    },
  },
  colTotal: {
    marginTop: 5,
  },
  total: {
    fontWeight: 400,
  },
});

export default function OrderResumeTotal() {
  const classes = useStyles();

  const order = useSelector(state => state.order);

  return (
    <>
      {order.products.length > 0 && (
        <div className={classes.container}>
          <div>
            <Typography>Subtotal</Typography>
          </div>

          <div>
            <Typography>{order.formattedSubtotal}</Typography>
          </div>

          <div>
            <Typography>Desconto {order.coupon && `(${order.coupon.name})`}</Typography>
          </div>

          <div>
            <Typography>{order.formattedDiscount}</Typography>
          </div>

          <div>
            <Typography>Taxa de entrega</Typography>
          </div>

          <div>
            <Typography>{order.formattedTax}</Typography>
          </div>

          <div>
            <Typography variant="h6" className={classes.colTotal}>
              Total
            </Typography>
          </div>

          <div>
            <Typography variant="h6" className={`${classes.colTotal} ${classes.total}`}>
              {order.formattedTotal}
            </Typography>
          </div>
        </div>
      )}
    </>
  );
}
